import ComponentEx from 'components/ComponentEx';
import TabContainer from 'components/TabContainer';
import { AppBar } from '@material-ui/core';
import { Grid } from '@material-ui/core';
import { Paper } from '@material-ui/core';
import { Tabs, Tab } from '@material-ui/core';
import { Typography } from '@material-ui/core';
import { getTxt } from 'global/appGlobal';
import { withStyles } from '@material-ui/core/styles';
import * as Icon from '@material-ui/icons';
import React from 'react';
import { compose, graphql } from 'react-apollo';
import { Link } from 'react-router-dom';
import ReactSVG from 'react-svg';
import NavPills from 'components/NavPills/NavPills';
import ItemGrid from 'components/Grid/ItemGrid';
import HeaderViewItem from 'components/HeaderViewItem';
import LinearProgressEx from '../../components/LinearProgressEx';
import { DictionaryTypes, getLabel } from '../../global/dictionaryCache';
import Custom_Fields_View from '../../modules/publicInsType/Custom_Fields_View';
import { typeByIdQuery } from '../../modules/publicInsType/publicInsTypeQueries';
import Public_Ins_Type_Details_View from '../../modules/publicInsType/Public_Ins_Type_Details_View';
import GuarantyTypeSearch from '../../modules/guaranty/GuarantyTypeSearch';
import RegularCard from '../../components/dashboard/RegularCard';


const styles = theme => ({

   root: {
        backgroundColor: theme.palette.grey,
        margin: theme.spacing.unit * 3,
        marginTop: 0,
    },

    button: {
        margin: theme.spacing.unit,
    },

    badge: {
        margin: `0 ${theme.spacing.unit * 2}px`,
        marginTop: 0,
    },

    gridRoot: {
        height: '100%',
    },


    formCaption: {
        marginTop: theme.spacing.unit,
        marginBottom: theme.spacing.unit * 2,
        width: '100%',
        position: 'relative',
        height: 40,
    },
    formCaptionLabel: {
        position: 'absolute',
        //color: theme.palette.primary1,
        backgroundColor: 'transparent',
        left: 25,
        paddingLeft: 10,
        paddingRight: 10,
    },

    rootPaper: theme.mixins.gutters({

        paddingTop: 0,
        paddingBottom: 0,
        marginTop: 0,// theme.spacing.unit * 3,

    }),

    formHeaderRoot: {
        padding: theme.spacing.unit * 2,
        position: 'relative',
    },

    formHeaderFieldLabel: {
        color: theme.palette.text.disabled,
        fontWeight: 'bold',

    },

    tableHeader: {
        backgroundColor: theme.palette.background.paper,
    },

    headerIcon: {
        width: theme.spacing.unit * 8,
        height: theme.spacing.unit * 9,
        marginRight: theme.spacing.unit * 2,
    },

    cmdBar: {
        position: 'absolute',
        right: theme.spacing.unit * 3,
    },
    dialogText: {
        color: theme.palette.error.main,
    },

    noGuarantyErrorText: {
        ...theme.typography.body1,
        color: theme.palette.error.main,
        paddingLeft: theme.spacing.unit * 2,
    },

});

const tabsStateGlobalId = 'Public_Ins_Type_View_Tab';

class Public_Ins_Type_View extends ComponentEx {

    innerID = 'Public_Ins_Type_View';

    state = {
        value: window[tabsStateGlobalId] ? window[tabsStateGlobalId] : 0,
    };

    handleChange = (event, value) => {
        this.setState({ value });
    };

    componentWillUnmount() {
        window[tabsStateGlobalId] = this.state.value;
        delete window.Public_Ins_Type_View_Refresh;
    }

    render() {

        const { classes } = this.props;
        const { value } = this.state;

        const loading = this.props.data.loading;
        const item = this.props.data.public_Ins_Type_By_Id;
        window.Public_Ins_Type_View_Refresh = this.props.data.refetch;


        return (


            <div className={classes.root}>

                <LinearProgressEx loading={loading} />

                <RegularCard

                    headerColor="red"
                    cardTitle={item && item.public_ins_type_name}
                    cardSubtitle={getTxt('User Insurance Type')}
                    content={
                        <Grid container>
                            <ItemGrid xs={12} sm={12} md={4}>
                                <HeaderViewItem l={getTxt('Key')}>
                                    <Typography variant="body1" >
                                        {item && <span>{item.public_ins_type_cd}</span>}
                                    </Typography>
                                </HeaderViewItem>
                            </ItemGrid>

                            <ItemGrid xs={12} sm={12} md={8}>
                                <HeaderViewItem l={getTxt('Real Ins. Type')}>
                                    <Typography variant="body1" >
                                        {item &&
                                            <Link to={`/real_insurance_types/view/${item.actual_ins_type_cd}`} >{getLabel(DictionaryTypes.InternalInsuranceType, item.actual_ins_type_cd)}</Link>
                                        }
                                    </Typography>
                                </HeaderViewItem>
                            </ItemGrid>
                        </Grid>
                    }
                />



                <NavPills
                    color="warning"
                    onChange={this.handleChange}
                    alignCenter
                    active={value}
                    tabs={[
                        {
                            tabButton: getTxt('Used Fields'),
                            tabIcon: Icon.List,
                            tabContent: (
                                <TabContainer>
                                    {item && <Custom_Fields_View
                                        id={item.public_ins_type_id}
                                        history={this.props.history}
                                        noCaption
                                    />}
                                </TabContainer>
                            ),
                        },
                        {
                            tabButton: getTxt('Guaranties'),
                            tabIcon: Icon.Drafts,
                            tabContent: (
                                <TabContainer>
                                    {item && <GuarantyTypeSearch
                                        insuranceType={item.public_ins_type_cd}
                                        history={this.props.history}
                                    />}
                                </TabContainer>
                            ),
                        },
                        {
                            tabButton: getTxt('Details'),
                            tabIcon: Icon.Details,
                            tabContent: (
                                <TabContainer>
                                    {item && <Public_Ins_Type_Details_View
                                        id={item.public_ins_type_id}
                                        history={this.props.history}
                                    />}
                                </TabContainer>
                            ),
                        },

                    ]}
                />





            </div >
        );
    }
}


export default compose(
    graphql(typeByIdQuery, {
        options: props => ({
            variables: {
                id: (!props.id ? (props.match.params.id ? props.match.params.id : 'new') : props.id),
                customFields: false,
            },
            fetchPolicy: 'network-only',
            options: {
                errorPolicy: 'all',
            },
        }),
    }),
)(withStyles(styles)(Public_Ins_Type_View));

